<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full pt-2">
        <div class="table-heading pt-2" style="margin-bottom: 0px">
          {{ ClientData.clientCode }}
        </div>
      </div>
      <div class="vx-col w-full">
        <div class="details-layout-2 p-2">
          <vs-table stripe :data="ClientData" class="details-table">
            <template slot="header">
              <div class="details-header w-full">
                <div>{{ $t("customers.label.billProfile") }}</div>
              </div>
              <div class="details-header w-full">
                <ul class="horizontal-sm-btn flex float-right">
                  <li>
                    <div
                      class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                    >
                      <vs-button
                        style="margin-top: -10px"
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editData(id)"
                        size="small"
                        >{{ $t("customers.label.edit") }}</vs-button
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </template>
            <template>
              <!-- </vs-thead> -->
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_day_of_month") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.billDayOfMonth }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.hot_bill") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.hotBill }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_currency") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.billCurrencyName }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_frequency") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.billFrequencyName }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_segment") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.billSegment }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.next_bill_date") }} :</vs-td
                >

                <vs-td class="black">{{
                  toDate(ClientData.nextBillDay)
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.last_bill_day") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.lastBillDay }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.last_bill_no") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.lastBillNo }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.payment_type") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.paymentType }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_suppression_flag") }} :</vs-td
                >

                <vs-td class="black">{{
                  ClientData.billSuppressionFlag
                }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.bill_suppression_flag") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.billSuppressionId }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.first_bill") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.firstBill }}</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td class="light"
                  >{{ $t("customers.label.collection_name") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.collectionName }}</vs-td>
                <vs-td class="light"
                  >{{ $t("customers.label.collection_status") }} :</vs-td
                >

                <vs-td class="black">{{ ClientData.collectionStatus }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.edit_bill_profile')"
        :active.sync="editContactpopup"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 ml-2">
            <div class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small
                  class="date-label font-semibold"
                  >{{ $t("customers.label.bill_day_of_month") }}</small
                >
                <v-select
                  label="billCycleName"
                  :options="clientsDataEditId.billingCycleData"
                  v-model="editClient.billCycleId"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="(obj) => obj.id"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                :label="$t('customers.label.last_bill_no')"
                v-model="editClient.lastBillNo"
                class="w-full font-semibold"
                icon-no-border
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small
                  class="date-label font-semibold"
                  style="margin-top: 15px"
                  >{{ $t("customers.label.bill_currency") }}</small
                >
                <v-select
                  style="margin-top: 15px"
                  label="name"
                  :options="clientsDataEditId.currencyData.currencyOptions"
                  v-model="editClient.billCurrency"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="(obj) => obj.id"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                style="margin-top: 15px"
                :label="$t('customers.label.payment_type')"
                v-model="editClient.paymentType"
                class="w-full font-semibold"
                icon-no-border
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("customers.label.bill_frequency")
                }}</small>
                <v-select
                  label="billFrequencyCode"
                  :options="clientsDataEditId.billFrequencyCodeData"
                  v-model="editClient.billFrequency"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="(obj) => obj.id"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div style="height: 10px"></div>
              <vs-checkbox
                class="mt-3 font-semibold"
                v-model="billSuppressionChecked"
                >{{ $t("customers.label.bill_suppression") }}</vs-checkbox
              >
              <div style="height: 20px"></div>
            </div>
            <div v-if="editClient.billSegment" class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("customers.label.bill_segment")
                }}</small>
                <v-select
                  label="type"
                  :options="clientsDataEditId.serviceTypes"
                  v-model="editClient.billSegment"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  :reduce="(obj) => obj.id"
                  class="min-w-200 w-full vs-search-category font-semibold"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div style="height: 10px"></div>

              <vs-checkbox
                class="mt-3 font-semibold"
                v-model="firstBillChecked"
                >{{ $t("customers.label.first_bill") }}</vs-checkbox
              >
              <div style="height: 20px"></div>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.next_bill_day")
                }}</small>
                <datepicker
                  :placeholder="$t('customers.label.select_date')"
                  v-model="editClient.nextBillDay"
                  class="w-full font-semibold"
                  :format="formatDate"
                />
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div style="height: 10px"></div>

              <vs-checkbox
                class="mt-3 font-semibold"
                v-model="hotBillChecked"
                >{{ $t("customers.label.hot_bill") }}</vs-checkbox
              >
              <div style="height: 20px"></div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div style="height: 10px"></div>

              <vs-checkbox
                class="mt-3 font-semibold"
                v-model="collectionStatusChecked"
                >{{ $t("customers.label.collectionStatus") }}</vs-checkbox
              >
              <div style="height: 20px"></div>
            </div>
            <div v-if="editClient.lastBillDay" class="vx-col sm:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.last_bill_day")
                }}</small>
                <datepicker
                  :placeholder="$t('customers.label.select_date')"
                  v-model="editClient.lastBillDay"
                  class="w-full font-semibold date-width"
                />
              </div>
            </div>
          </div>

          <div class="center">
            <span class="ml-4 mr-1">
              <vs-button
                type="border"
                style="width: 190px; margin-top: 20px"
                @click="editContactpopup = false"
                >{{ $t("customers.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button
                style="width: 190px; margin-top: 20px"
                :disabled="disableSaveBtn"
                @click="saveEditData"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";

const editBillProfileEmpty = {
  billCycleId: "",
  billCurrency: "",
  billFrequency: "",
  billSegment: "",
  nextBillDay: moment().format("dd MMMM yyyy"),
  lastBillDay: "",
  lastBillNo: 0,
  paymentType: 0,
  billSuppressionFlag: false,
  billSuppressionId: false,
  firstBill: false,
  hotBill: false,
  collectionStatus: false,
  dateFormat: "dd MMMM yyyy",
  locale: "en",
};

export default {
  props: ["clientId"],
  data() {
    return {
      id: 0,
      clientCode: "",
      editClient: editBillProfileEmpty,
      editContactpopup: false,
      disableSaveBtn: false,
      validateMsg: "",
      hotBillChecked: false,
      collectionStatusChecked: false,
      firstBillChecked: false,
      billSuppressionChecked: false,
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
  },
  computed: {
    ClientData() {
      return this.$store.getters["customerBillprofile/getClientBillId"];
    },
    editBill() {
      return this.$store.getters["customerBillprofile/getClientEditBillId"];
    },

    ...mapState({
      clientsDataEditId: (state) => state.customerBillprofile.clientsDataEditId,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    validateDayOfMonth(value) {
      const numValue = parseInt(value);
      if (isNaN(numValue) || numValue < 1 || numValue > 31) {
        this.disableSaveBtn = true;
        this.validateMsg = "Enter a number between 0 and 32.";
      } else {
        this.disableSaveBtn = false;
        this.validateMsg = "";
      }
    },
    backBtn() {
      this.$router.push({
        name: "View Customer",
        params: { id: this.id, moreInfo: true },
      });
    },
    toDate(data) {
      const d = new Date(data);
      return moment(d).format("DD MMMM YYYY");
    },
    async editData(id) {
      this.editContactpopup = true;
      this.id = id;
      await this.$store.dispatch("customerBillprofile/setClientEditId", id);
      this.editClient.billCurrency = this.clientsDataEditId.billCurrency;
      this.editClient.billCycleId =
        this.clientsDataEditId.billCycleId;
      this.editClient.billFrequency = this.clientsDataEditId.billFrequency;
      if (this.clientsDataEditId.billSegment) {
        this.editClient.billSegment = this.clientsDataEditId.billSegment;
      }
      this.editClient.nextBillDay = this.toDate(
        this.clientsDataEditId.nextBillDay
      );
      if (this.clientsDataEditId.lastBillDay) {
        this.editClient.lastBillDay = this.toDate(
          this.clientsDataEditId.lastBillDay
        );
      }
      this.editClient.lastBillNo = this.clientsDataEditId.lastBillNo;
      this.editClient.paymentType = this.clientsDataEditId.paymentType;
      this.billSuppressionChecked = this.clientsDataEditId.billSuppressionFlag;
      this.editClient.billSuppressionFlag = this.billSuppressionChecked;
      this.firstBillChecked = this.clientsDataEditId.firstBill;
      this.editClient.firstBill = this.firstBill;
      this.hotBillChecked = this.clientsDataEditId.hotBill;
      this.editClient.hotBill = this.hotBill;
      this.collectionStatusChecked = this.clientsDataEditId.collectionStatus;
      this.editClient.collectionStatus = this.collectionStatusChecked;
    },

    async getClientCodeById() {
      try {
        this.$store.dispatch("customerBillprofile/setClientId", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async saveEditData() {
      this.billSuppressionChecked
        ? (this.editClient.billSuppressionId = 1)
        : (this.editClient.billSuppressionId = 0);
      this.billSuppressionChecked
        ? (this.editClient.billSuppressionFlag = "Y")
        : (this.editClient.billSuppressionFlag = "N");
      this.firstBillChecked
        ? (this.editClient.firstBill = "Y")
        : (this.editClient.firstBill = "N");
      this.hotBillChecked
        ? (this.editClient.hotBill = "Y")
        : (this.editClient.hotBill = "N");
      this.collectionStatusChecked
        ? (this.editClient.collectionStatus = true)
        : (this.editClient.collectionStatus = false);
      this.editClient.nextBillDay = moment(this.editClient.nextBillDay).format(
        "DD MMMM yyyy"
      );
      if (this.editClient.lastBillDay) {
        this.editClient.lastBillDay = moment(
          this.editClient.lastBillDay
        ).format("DD MMMM yyyy");
      }
      try {
        await this.$store.dispatch("customerBillprofile/setClientEditSave", {
          id: this.id,
          data: this.editClient,
        });
        this.editContactpopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Bill Profile Edited Successfully!",
          type: "success",
        });
        this.getClientCodeById();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async putClientCodeById() {
      try {
        await this.$store.dispatch(
          "customerBillprofile/setClientEditId",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    // this.getClientEditBillId();
    this.id = this.$route.params.id;
    this.clientCode = this.$route.params.clientCode;
    this.getClientCodeById();
    this.putClientCodeById();
    // this.callTaxMapping(this.chargeCode);
  },
};
</script>
